import { render, staticRenderFns } from "./ProjectEdit.vue?vue&type=template&id=2176b5d6&scoped=true"
import script from "./ProjectEdit.vue?vue&type=script&lang=js"
export * from "./ProjectEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2176b5d6",
  null
  
)

export default component.exports